import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14.693 3.885c.745-.807 1.118-1.21 1.514-1.446a3.1 3.1 0 0 1 3.102-.047c.403.224.787.616 1.555 1.4.768.785 1.152 1.178 1.371 1.589.528.992.51 2.194-.046 3.17-.23.404-.625.785-1.416 1.546l-9.403 9.057c-1.498 1.443-2.247 2.164-3.183 2.53s-1.965.338-4.022.285l-.28-.008c-.627-.016-.94-.024-1.122-.231s-.157-.526-.108-1.164l.027-.346c.14-1.796.21-2.694.56-3.502.352-.807.957-1.463 2.167-2.774zM13.62 4l7 7"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14.62 22h8"
    }, null, -1)
  ])))
}
export default { render: render }